module.exports = __webpack_public_path__ + "img/icon-blog-xs.f640cbb0.svg";